import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { ApiBaseUrl } from '../../http';
import { IRdv, RdvFormData } from './rdv.type';
import { PaginationResults, TypeQuery } from '../user/user.type';
import { QueryUrl } from '../../Utils';

const RdvApi = createApi({
    reducerPath: "rdvApi",
    tagTypes: ["rdv"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        addOrUpdateRdv: build.mutation<
            IRdv,
            { slug?: string; data: IRdv }
        >({
            query: ({ slug, data }) => ({
                url: slug ? `rdvs/${slug}/` : `rdvs/`,
                method: slug ? "PUT" : "POST",
                body: data,
            }),
            invalidatesTags: ["rdv"],
        }),
        getRdvs: build.query<PaginationResults<IRdv>, TypeQuery>({
            query: (query) => QueryUrl(`rdvs/`, query),
            providesTags: ["rdv"],
        }),
        deleteRdv: build.mutation<RdvFormData, string>({
            query: (slug) => ({
                url: `rdvs/${slug}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["rdv"],
        }),
    }),
});

export default RdvApi

export const {
    useAddOrUpdateRdvMutation,
    useGetRdvsQuery,
    useDeleteRdvMutation,
} = RdvApi;